import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p><inlineCode parentName="p">{`vets-website`}</inlineCode>{` uses modern browser features to provide a secure experience for veterans. In general, these features are automatically included through the deployment process and require no configuration by front end engineers. `}</p>
    <p><em parentName="p">{`This is an overview not an implementation guide. These rules apply to VA.gov production environments. Not all security features will be used in local, development, or staging environments.`}</em>{` `}</p>
    <h2 {...{
      "id": "https"
    }}>{`HTTPS`}</h2>
    <ul>
      <li parentName="ul">{`All connections made to VA.gov must be secure (HTTPS)`}</li>
      <li parentName="ul">{`VA.gov implements HSTS and automatically redirects to a secure protocol if a non secure connection is attempted `}</li>
    </ul>
    <h2 {...{
      "id": "cross-origin-resource-sharing-cors"
    }}>{`Cross-Origin Resource Sharing (CORS)`}</h2>
    <ul>
      <li parentName="ul">{`Some cross origin connections made to VA.gov must support CORS including `}<strong parentName="li">{`all`}</strong>{` XHR connections and web font downloads. `}</li>
      <li parentName="ul">{`Updates to CORS headers returned by `}<inlineCode parentName="li">{`vets-api`}</inlineCode>{` services or `}<inlineCode parentName="li">{`vets-website`}</inlineCode>{` assets must be made through the devops team and must be reviewed by `}<a parentName="li" {...{
          "href": "https://github.com/orgs/department-of-veterans-affairs/teams/va-platform-cop-frontend"
        }}>{`va platform frontend cop`}</a>{`. Example:  `}
        <ul parentName="li">
          <li parentName="ul">{`Your application is on a VA.gov subdomain, needs to connect to `}<inlineCode parentName="li">{`vets-api`}</inlineCode>{`, but is not currently listed in the allowed origins`}</li>
        </ul>
      </li>
      <li parentName="ul">{`More `}<a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS"
        }}>{`info on cors`}</a></li>
      <li parentName="ul">{`CORS configurations: `}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/department-of-veterans-affairs/devops/blob/ec2b1802c10e1e48d475a97f75a5a14fd6e552e7/terraform/environments/dsva-vagov-prod/main.tf#L177-L180"
            }}>{`production`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/department-of-veterans-affairs/devops/blob/cbab63cdf0595f4172b43d90cd46233997b37324/terraform/environments/dsva-vagov-staging/s3_buckets.tf#L16-L19"
            }}>{`staging`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "content-security-policy-csp"
    }}>{`Content Security Policy (CSP)`}</h2>
    <ul>
      <li parentName="ul">{`All VA.gov pages return a Content Security Policy header that allows only known scripts to run on the page`}</li>
      <li parentName="ul">{`The CSP is enforced i.e. not set to `}<inlineCode parentName="li">{`report-only`}</inlineCode></li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`report-uri`}</inlineCode>{` points to a VA platform error capturing service (Sentry)`}
        <ul parentName="li">
          <li parentName="ul">{`VA.gov throttles these reports by including the `}<inlineCode parentName="li">{`report-uri`}</inlineCode>{` only on a small % of responses`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Updates to CSP headers returned by or `}<inlineCode parentName="li">{`vets-website`}</inlineCode>{` assets must be made through the devops team and must be reviewed by `}<a parentName="li" {...{
          "href": "https://github.com/orgs/department-of-veterans-affairs/teams/va-platform-cop-frontend"
        }}>{`va platform frontend cop`}</a></li>
      <li parentName="ul">{`More `}<a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP"
        }}>{`info on CSP`}</a></li>
      <li parentName="ul">{`CSP configurations:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/department-of-veterans-affairs/devops/blob/master/ansible/deployment/config/revproxy-vagov/vars/content_security_policy_vagov-prod.yml"
            }}>{`production`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/department-of-veterans-affairs/devops/blob/master/ansible/deployment/config/revproxy-vagov/vars/content_security_policy_vagov-staging.yml"
            }}>{`staging`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/department-of-veterans-affairs/devops/blob/master/ansible/deployment/config/revproxy-vagov/vars/content_security_policy_vagov-dev.yml"
            }}>{`dev`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      